export default function timeoutPromise (timeout=10000)
{
	return new Promise(function (resolve, reject)
	{
		setTimeout(() => resolve(), timeout);
	});
}